// Core type definitions shared across the app.

export type GeneratorKind =
  | 'solid'
  | 'gradient'
  | 'dotgrad'
  | 'perlin'
  | 'worley'
  | 'voronoi'
  | 'lattice'
  | 'image'
  | 'cellular';

export type FilterKind =
  | 'palette'
  | 'dither'
  | 'posterize'
  | 'threshold'
  | 'symmetry'
  | 'halftone';

export type LayerKind = GeneratorKind | FilterKind;

export type LayerCategory = 'generator' | 'filter';

export type BlendMode =
  | 'source-over'
  | 'multiply'
  | 'screen'
  | 'overlay'
  | 'darken'
  | 'lighten'
  | 'color-dodge'
  | 'color-burn'
  | 'hard-light'
  | 'soft-light'
  | 'difference'
  | 'exclusion'
  | 'hue'
  | 'saturation'
  | 'color'
  | 'luminosity';

export type Resolution = { w: number; h: number };

export type Layer = {
  id: string;
  kind: LayerKind;
  params: Record<string, unknown>;
  blend: BlendMode;
  opacity: number; // 0..1
  enabled: boolean;
  seed: number;
};

export type AppState = {
  resolution: Resolution;
  layers: Layer[];
  selectedLayerId: string | null;
  soloLayerId: string | null; // when set, only this layer renders
  time: number;               // animation tick (integer)
  paused: boolean;
  fps: number;                // playback frames per second
};

export type Theme = 'dark' | 'light';

export const DEFAULT_RESOLUTION: Resolution = { w: 256, h: 256 };

export const INITIAL_STATE: AppState = {
  resolution: DEFAULT_RESOLUTION,
  layers: [],
  selectedLayerId: null,
  soloLayerId: null,
  time: 0,
  paused: true,
  fps: 8,
};

export const STATE_VERSION = 1 as const;
